// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function urlSafeEncode(str) {
  return str.split('').map(char => char.charCodeAt(0).toString(16).padStart(2, '0')).join('');
}
export { urlSafeEncode };
